<template>
  <div class="history">
    <!-- card -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>工作量统计</span>
      </div>

      <!-- 筛选 -->
      <el-row>
        <!-- 时间选择 -->
        <el-col :span="7">
          <el-date-picker
            v-model="pickerDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            unlink-panels
            :picker-options="pickerOptions"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col>
        <!-- 搜索 -->
        <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="search"
          ></el-button>
        </el-col>
        <!-- <el-col :span="6"> -->
        <!-- <el-input
            placeholder="请输入登录用户名"
            v-model="params.uname"
            class="input-with-select"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input> -->
        <!-- </el-col> -->

        <el-col :span="15">&nbsp;</el-col>
        <!-- 下载 -->
        <el-col :span="1">
          <el-button
            v-if="tableData.length != 0"
            icon="el-icon-download"
            type="info"
            plain
            :loading="downloadLoading"
            @click="download"
          ></el-button>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <!-- <TzTable :tableData="tableData" :columns="columns" /> -->
      <el-table :data="tableData" border style="width: 100%" ref="table">
        <el-table-column
          v-for="(item, i) in column"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
        <el-table-column
          v-for="(item, i) in columns"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
// import tableData from '~mock/users/history'
import fileDownload from 'js-file-download'
import { checkWorkload, workloadExport } from '@/api/workload'
export default {
  components: {
    // TzTable
  },

  data() {
    return {
      downloadLoading: false,
      offset: '', //当前起始位置（page-1）*limit
      page: 1, //当前页
      limit: '10', //
      total: '',
      pickerDate: [], //日期 时间戳
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },

      // 表格固定列
      column: [
        {
          prop: 'submiterNo',
          label: '工号'
        },
        {
          label: '姓名',
          prop: 'submiterName'
        },
        {
          prop: 'type',
          label: '统计类型'
        },
        {
          prop: 'weights',
          label: '加权工作量'
        }
      ],
      // 表格动态列
      columns: [],
      // 表格数据
      tableData: [],
      equipmentForm: {
        // name: '',
        // region: '',
        // date1: '',
        // date2: ''
      },
      formLabelWidth: '150px'
    }
  },
  methods: {
    handleSizeChange(val) {
      this.limit = val
      this.listCheckWorkload()
    },
    handleCurrentChange(val) {
      this.page = val
      this.listCheckWorkload()
    },
    //选择日期事件
    handleDateChange(dialogPickerDate) {
      if (dialogPickerDate == null) {
        this.pickerDate = []
      }
      this.page = 1
      this.listCheckWorkload()
    },

    //获取数据
    listCheckWorkload() {
      var data = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      }
      // console.log(this.pickerDate, 'fdsfasdf')
      checkWorkload(data).then((res) => {
        console.log(res.data, '工作量')
        if (res.code == 402) {
          this.$message({
            message: res.data,
            duration: 4000
          })
        } else if (res.code == 200) {
          this.columns = []
          this.total = res.data.total
          this.tableData = res.data.rows
          this.equipmentForm = res.data.equipmentType
          res.data.equipmentType.forEach((element) => {
            let obj = {
              label: element.label,
              prop: element.label,
              value: element.value
            }
            this.columns.push(obj)
          })

          this.tableData.forEach((item) => {
            item.infos.forEach((ele) => {
              let obj1 = {}
              obj1[ele.deviceTypeName] = ele.count1
              Object.assign(item, obj1)
            })
          })
          console.log(this.tableData)
        }
      })
    },
    // 点击搜索
    search() {
      this.listCheckWorkload()
    },
    //弹窗确定
    sbmit() {
      console.log(this.radio)
    },
    //下载
    download() {
      this.downloadLoading = true
      var data = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      workloadExport(data).then((res) => {
        fileDownload(res, '工作量统计.xlsx')
      })
      this.downloadLoading = false
    }
  },
  created() {},
  mounted() {
    this.listCheckWorkload()
  }
}
</script>

<style lang="scss" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
}
</style>
